<script setup lang="ts">
import { AdminPermissionResource, PermissionLevel } from '@swipe4work/models-orval'
import IntegrationErrorAlertPolicyDialog from '@/features/settings/dialogs/IntegrationErrorAlertPolicyDialog.vue'
import IntegrationErrorsDataTable from '@/features/settings/components/IntegrationErrorsDataTable.vue'

definePage({
  path: '/settings/integration-errors',
  name: '/settings/IntegrationErrors',
  meta: {
    title: 'ATS-foutmeldingen',
    permission: {
      resource: 'IntegrationErrors',
      level: 'Read',
    },
  },
})

const dialog = useDynamicDialog()

function openAlertPolicy() {
  dialog.open(IntegrationErrorAlertPolicyDialog, {
    props: {
      modal: true,
      closable: true,
      showHeader: false,
      dismissableMask: true,
      style: {
        width: 'auto',
        height: 'auto',
      },
    },
  })
}
</script>

<template>
  <div class="flex flex-col gap-6 p-6">
    <Card>
      <template #content>
        <div class="flex flex-col gap-4">
          <div class="flex flex-wrap items-center justify-between gap-4">
            <div class="flex flex-col gap-1">
              <h3 class="m-0 text-lg text-surface-900 font-bold">
                ATS-foutmeldingen
              </h3>
              <span class="text-xs text-surface-500">
                Foutmeldingen van de ATS-koppelingen. Deze worden hier vastgelegd in plaats van in Sentry;
                een foutsoort die te vaak voorkomt wordt alsnog als incident in Sentry gemeld.
              </span>
            </div>
            <Button
              v-permission="{ resource: AdminPermissionResource.IntegrationErrors, level: PermissionLevel.Write }"
              label="Meldingen instellen"
              icon="fa-regular fa-bell-on"
              outlined
              severity="secondary"
              class="bg-surface-0"
              @click="openAlertPolicy"
            />
          </div>

          <IntegrationErrorsDataTable />
        </div>
      </template>
    </Card>
  </div>
</template>
